<template>
    <div>
        <Loading :isLoading="isLoading" />
        <CRow style="height:100% !important" >
            <CCol col="12" xl="12" style="height:100% !important">
                <transition name="slide">
                    <CCard style="height:100% !important">
                        <CCardBody height="100%">
                            <CRow>
                                <div class="col-sm-2 offset-sm-2">
                                    <CSelect 
                                        :placeholder="$t('typeVehicles.placeholder')" 
                                        :label="$t('typeVehicles.title')" 
                                        :options="typeVehicles"
                                        :value.sync="field.type_vehicle_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-2">
                                    <CSelect 
                                        :placeholder="$t('states.placeholder')" 
                                        :label="$t('states.title')" 
                                        :options="states"
                                        :value.sync="field.state_id"
                                        :plain="true"
                                    ></CSelect>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="warning" @click="onClean" class="m-2">
                                        <CIcon :content="deleteIcon" /> {{ $t('button.clean') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1">
                                    <CButton color="success" @click="onFilter" class="m-2">
                                        <CIcon :content="btnSearch" /> {{ $t('button.filter') }}
                                    </CButton>
                                </div>
                                <div class="col-sm-1 pt-2 ml-2">
                                    <CIcon :content="iconDiamond" size="2xl"/>
                                    <label class="ml-2">{{getRandomInt}}</label>
                                </div>
                                <div class="col-sm-1 pt-2 ml-2">
                                    <CIcon :content="iconArchive" size="2xl"/>
                                    <label class="ml-2">{{total}}</label>
                                </div>
                            </CRow>
                            <div v-infinite-scroll="loadMore" 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="13"
                            >
                                <CRow v-for="item of visibleData" :key="item.id">
                                    <div class="col-sm-6 offset-sm-3">
                                        <DirectoryItem 
                                            :item="item" 
                                            @onShowItem="onShowItem" 
                                        />
                                    </div>
                                </CRow>
                            </div>
                        </CCardBody>  
                    </CCard>
                </transition>
            </CCol>
        </CRow>
        <CModal
            color="warning"
            :show.sync="showDetail"
            :title="$t('charges.detail')"
        >
            <div v-if='!isAuth'>
                {{messageLogin}}
            </div>
            <div v-else-if="!canViewDetail">
                <CRow>
                    <div class="col-sm-12">
                        {{messagePremium}}
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3 mt-5">
                        <a :href="urlWhatsappPremium" class="btn-whatsapp" target="_blank">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
            <div v-else>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            Folio:
                        </label>
                   </div>
                   <div class="col-sm-10">
                        <label class="label-detail">
                            {{item.id}}
                        </label>
                    </div>
                </CRow>
                <CRow style="margin: 40px !important">
                    <div class="col-sm-12" style="text-align: center;">
                        <label class="label-detail">
                            {{item.name}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            En:
                        </label>
                    </div>
                    <div class="col-sm-10">
                        <label class="label-detail">
                            {{itemStateName}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-2">
                        <label class="label-detail">
                            Correo:
                        </label>
                    </div>
                    <div class="col-sm-10">
                        <label class="label-detail">
                            {{displayEmail}}
                        </label>
                    </div>
                </CRow>
                <CRow v-for="type in item.type_vehicle" :key="type.id">
                    <div class="col-sm-12">
                        <label class="label-detail">
                            {{type.name}}
                        </label>
                    </div>
                </CRow>
                <CRow>
                    <div class="col-sm-6 offset-sm-3">
                        <a :href="urlWhatsapp" class="btn-whatsapp" target="_blank" @click.prevent="onContactWhatsapp">
                            <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                        </a>
                    </div>
                </CRow>
            </div>
            <template #footer>
                <CButton @click="showDetail = false" color="warning">Cerrar</CButton>
            </template>
        </CModal>
        <CModal
            color="warning"
            :show.sync="showPremiumContact"
            :title="$t('charges.detail')"
        >
            <CRow>
                <div class="col-sm-12">
                    {{messagePremium}}
                </div>
            </CRow>
            <CRow>
                <div class="col-sm-6 offset-sm-3 mt-5">
                    <a :href="urlWhatsappPremium" class="btn-whatsapp" target="_blank">
                        <CIcon :content="iconChat" size="3xl"/> {{ $t('button.whatsapp') }} 
                    </a>
                </div>
            </CRow>
            <template #footer>
                <CButton @click="showPremiumContact = false" color="warning">Cerrar</CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import axios from 'axios'
import store from '../../store'
import catalog from '../../hooks/catalogs';
import DirectoryItem from "./components/Item.vue";
import Loading from "../../components/Loading.vue";
import { canOpenDetail } from '../../utils/premiumAccess';
import { cilPlus, cilSearch, cilTrash, cilChatBubble, cilInbox, cilDiamond } from '@coreui/icons';

export default {
    name: 'Charges',
    mixins: [catalog],
    components: {
        Loading,
        DirectoryItem
    },
    data() {
        return {
            page: 1,
            total: 0,
            item: {},
            data: [],
            states: [],
            types: [
                {
                    value: "1",
                    label: "Cargas premium",
                }
            ],
            busy: false,
            lastPage: 1,
            isAuth: false,
            isPremium: false,
            field: {
                type_id: '',
                state_id: '',
                type_vehicle_id: '',
            },
            isLoading: true,
            addIcon: cilPlus,
            typeVehicles: [],
            showDetail: false,
            showPremiumContact: false,
            btnSearch: cilSearch,
            deleteIcon: cilTrash,
            iconChat: cilChatBubble,
            iconArchive: cilInbox,
            iconDiamond: cilDiamond,
        }
    },
    methods: {
        onShowItem(item) {  
            this.item = item;
            this.showDetail = true;
        },
        onContactWhatsapp() {
            if (!this.isPremium) {
                this.showPremiumContact = true;
                return;
            }

            window.open(this.urlWhatsapp, '_blank');
        },
        maskEmail(email) {
            if (email == null || email.trim().length === 0) {
                return "";
            }

            const parts = email.trim().split("@");
            if (parts.length !== 2) {
                return "****";
            }

            const name = parts[0];
            const domain = parts[1];
            const visible = name.slice(0, Math.min(3, name.length));

            return `${visible}****@${domain}`;
        },
        onShowCloseItem() {  
            this.item = {};
            this.showDetail = false;
        },
        onClean() {  
            this.field = {
                type_id: '',
                state_id: '',
                type_vehicle_id: '',
            };

            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        onFilter() {  
            this.page = 1;
            this.data = [];
            this.lastPage = 1;
            this.isLoading = true;
            this.onGetRecords();
        },
        loadMore() {  
            let self = this;

            if (self.lastPage > self.page) {
                self.page++;
                self.busy = true;
                self.isLoading = true;
                self.onGetRecords();
            }
        },
        onGetRecords() {  
            let self = this;
            const token = localStorage.getItem('token', null);

            var url = `directories?page=${this.page}&vehicleId=${this.field.type_vehicle_id}&stateId=${this.field.state_id}`;

            axios.get(url, {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                    }
                })
                .then(response => {
                    self.lastPage = response.data.last_page;
                    self.total = (response.data.total + 2100);
                    self.data.push(...response.data.data);
                    self.busy = false;
                    self.isLoading = false;
                }).catch(error => {
                    if (error.response.status === 401) {
                        self.$router.push({ path: '/login' });
                    } else {
                        self.$toast.error(error.response.data.message);
                    }
                });
        },
        getConfiguration() {
            axios.post('/configuration', {
                version: 0,
            }).then(response => {
                store.dispatch('setConfiguration', response.data);
            }).catch(error => {
                this.$toast.error(error.response.data.message);
            });
        }
    },
    computed: {
        messageLogin() {
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return store.state.configuration.configuration.registrate;
            } else {
                return "";
            }
        },
        messagePremium() {
            if (store.state.configuration != null) {
                return store.state.configuration.configuration.text_not_show_premium_trip;
            } else {
                return "aoeu";
            }
        },
        itemStateName() {
            return this.item.state != null ? this.item.state.name : "";
        },
        displayEmail() {
            if (this.isPremium) {
                return this.item.email;
            }

            return this.maskEmail(this.item.email);
        },
        urlWhatsapp() {
            return "https://wa.me/"+this.item.phone;
        },
        urlWhatsappPremium() {
            if (store.state.configuration != null 
                && store.state.configuration.configuration != null) {
                return "https://wa.me/"+store.state.configuration.configuration.text_not_show_premium_trip_phone;
            } else {
                return "";
            }
        },
        getRandomInt() {
            var min = 2000; 
            var max = 3000;
            min = Math.ceil(min);
            max = Math.floor(max);
            return Math.floor(Math.random() * (max - min + 1) + min);
        },
        visibleData() {
            return this.data.filter((item) => {
                return item.ad || (item.state && item.state.name && item.state.name.trim().length > 0);
            });
        },
        canViewDetail() {
            return canOpenDetail(this.isPremium, store.state.user);
        },
    },
    mounted() {
        let self = this;
        self.isPremium = (store.state.user != null && store.state.user.ver_dnt != null) ? store.state.user.ver_dnt : false;
        self.isAuth = localStorage.getItem('login', false) ?? false;
        self.getConfiguration();

        axios.get(`type-vehicle`)
            .then(response => {
                response.data.forEach(function(record){
                    self.typeVehicles.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        axios.get(`states`)
            .then(response => {
                response.data.forEach(function(record){
                    self.states.push({
                        value: record.id,
                        label: record.name,
                    });
                });
            }).catch(error => {
                if (error.response.status === 401) {
                    self.$router.push({ path: '/login' });
                } else {
                    self.$toast.error(error.response.data.message);
                }
            });

        self.onGetRecords();
    }
}
</script>

<style>
    .label {
        color: white;
        font-size: 20px;
    }
    .label-detail {
        color: wihte;
        font-size: 20px;
    }
    .btn-detail {
        height: 50px; 
        padding: 10px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
    .btn-whatsapp {
        height: 50px; 
        padding: 20px;
        font-size: 20px;
        cursor: pointer;
        font-weight: bold;
        text-align: center; 
        border-radius: 25px; 
        background-color: grey; 
        color: white !important; 
        border: 2px solid white; 
    }
</style>
